<template>
    <div class="ah-page invoice-add-page">
        <div class="page-header bottom-margin" id="invoice-edit-page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">核銷轉開發票新增</h1>
                        <h1 v-if="form.sno">核銷轉開發票編輯</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <el-form :model="form" :rules="rules" ref="form" :label-position="isMobile() ? 'top' : 'right'" label-width="200px">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">核銷轉開發票</div>
                    </div>
                    <div class="panel-body">
                        <!-- <el-form-item prop="ioo" label="單號" v-if="form.ioo != null">
                            <el-input v-model="form.ioo" :disabled="true" />
                        </el-form-item> -->

                        <ReimbursementSelectedTableView v-if="isInit" :refence-invoces="form.refenceInvoces" :disabled="isEInvoice" @change="onInvoiceChange" />
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">發票項目</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="發票摘要" prop="description" :rules="rules.description">
                            <el-input
                                v-model="form.description"
                                type="textarea"
                                :maxlength="100"
                                show-word-limit
                                class="ah-el-input-textarea"
                                autosize
                                resize="none"
                                @keydown.enter.native="onDescriptionInputKeydown($event)"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="amt" label="含稅總額">
                            <ah-el-select-cny value="TWD" :disabled="true"></ah-el-select-cny>
                            <MoneyInput v-model="form.amt" style="margin-left: 6px; width: 240px" :disabled="true" />
                        </el-form-item>
                        <el-form-item prop="" label="銷售額(未稅)">
                            <ah-el-select-cny value="TWD" :disabled="true"></ah-el-select-cny>
                            <MoneyInput v-model="nonTaxAmt" style="margin-left: 6px; width: 240px" :disabled="true" />
                        </el-form-item>
                        <el-form-item prop="" label="稅金">
                            <ah-el-select-cny value="TWD" :disabled="true"></ah-el-select-cny>
                            <MoneyInput :value="form.amT_TAX" style="margin-left: 6px; width: 240px" :disabled="true" />
                        </el-form-item>

                        <el-form-item prop="" label="發票項目">
                            <div style="text-align: right; margin-bottom: 20px; line-height: 150%;">
                                <el-checkbox v-model="useTaxIncludedAmt" class="use-tax-included-checkbox">以含稅單價輸入</el-checkbox>
                                <div v-if="useTaxIncludedAmt" class="use-tax-included-hint">僅供未稅單價參考，實際以未稅金額計算發票總額</div>
                            </div>
                            <el-table :data="form.items" empty-text="無項目" show-summary :summary-method="invoiceItemsGetSummary" size="small" class="invoice-item-table">
                                <el-table-column prop="iteM_NAM" label="品名（必填)">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'items.' + scope.$index + '.iteM_NAM'" :rules="rules.invoiceItemNam" label-width="0">
                                            <el-input v-model="scope.row.iteM_NAM" class="item-name" maxlength="200" show-word-limit :disabled="isEInvoice" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="qty" label="數量" width="75">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'items.' + scope.$index + '.qty'" :rules="rules.invoiceItemQty" label-width="0">
                                            <el-input v-model.number="scope.row.qty" @keyup.native="onItemQtyChange(scope.row)" :disabled="isIteM_NAMDisabled(scope.row)" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="unit" label="單位" width="75">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'items.' + scope.$index + '.unit'" :rules="rules.invoiceItemUnit" label-width="0">
                                            <el-input v-model="scope.row.unit" :disabled="isIteM_NAMDisabled(scope.row)" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="pri" label="未稅單價" width="150">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'items.' + scope.$index + '.pri'" :rules="rules.invoiceItemPri" label-width="0">
                                            <money-input
                                                v-model="scope.row.pri"
                                                :precision="2"
                                                :disabled="useTaxIncludedAmt || isIteM_NAMDisabled(scope.row)"
                                                @change="onItemNonTaxedPriChange(scope.row)"
                                            />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="useTaxIncludedAmt" prop="taxedPri" width="150">
                                    <template slot="header">
                                        <div style="color: #463cb2">含稅單價</div>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'items.' + scope.$index + '.taxedPri'" :rules="rules.invoiceItemPri" label-width="0">
                                            <money-input
                                                v-model="scope.row.taxedPri"
                                                :precision="2"
                                                :disabled="!useTaxIncludedAmt || isIteM_NAMDisabled(scope.row)"
                                                @change="onItemTaxedPriChange(scope.row)"
                                            />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="amt" label="金額（未稅）" width="120">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'items.' + scope.$index + '.amt'" :rules="rules.invoiceItemAmt" label-width="0">
                                            <money-input v-model="scope.row.amt" :disabled="true" :precision="2"/>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="" width="80">
                                    <template slot-scope="scope">
                                        <el-form-item v-if="!isEInvoice" label-width="0">
                                            <el-button size="mini" @click="removeInvoiceItem(scope.row)">刪除</el-button>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="invoice-item-table-below-contents">
                                <div class="note-text">平台計算的稅額、銷售額總計、總計等金額僅供參考。因各家稅務計算方式可能不同，請務必再次確認，如有誤差請自行調整。</div>
                                <el-button v-if="!isEInvoice" @click="addInvoiceItem" size="small" plain type="primary">新增項目</el-button>
                            </div>
                            <div v-if="(form.typ === 2 || form.typ === 3) && this.hasEInvoiceService && this.eInvoiceCmp === 'EZPay'" class="ah-warning-box">
                                <div class="title">ezPay電子發票注意事項</div>
                                <div class="content">
                                    <ul>
                                        <li>所有品名總字數須小於 30 - (項目個數) 個字。</li>
                                        <li>商品單位字數限中文 2 字或英數 6 字。</li>
                                        <li>所有金額皆須為整數</li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="(form.typ === 2 || form.typ === 3) && this.hasEInvoiceService && this.eInvoiceCmp === 'SunPay'" class="ah-warning-box">
                                <div class="title">紅陽電子發票注意事項</div>
                                <div class="content">
                                    <ul>
                                        <li>最多接受 10 項商品，每項商品名稱最多 100 個字元，不可有特殊字元。包含：*'&lt;&gt;[]"，如商品數量過多或金額有負值，建議整合為單一商品名稱傳送。</li>
                                        <li>紅陽平台列印 B2B 格式發票時，不會顯示發票開立備註。如需填寫發票備註，請填寫於品名。</li>
                                        <li>所有金額皆須為整數</li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="invoiceItemTotal != nonTaxAmt">
                                <el-alert type="error" :closable="false" style="margin-top: 10px" show-icon>項目總金額需等於稅前金額。</el-alert>
                            </div>
                            <el-alert
                                v-if="hasEInvoiceService && hasFloatInItemPrice"
                                type="warning"
                                :closable="false"
                                style="margin-top: 10px"
                                show-icon
                            >注意：此發票項目金額中含有小數點，將無法使用電子發票開立。</el-alert>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">發票內容</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="typ" label="發票類型">
                            <el-radio-group v-model="form.typ" :disabled="isEInvoice" @change="onTypChange">
                                <el-radio :label="3">三聯式</el-radio>
                                <el-radio :label="2">二聯式</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item v-if="hasEInvoiceService && form.typ === 3" prop="createE_Invoice" label="開立方式">
                            <el-radio-group v-model="form.createE_Invoice" :disabled="isEInvoice">
                                <el-radio :label="false">手開</el-radio>
                                <el-radio :label="true">電子發票</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item v-if="form.createE_Invoice" prop="" label="開立平台"> <ahEInvoicePlatformLabel :platformID="eInvoicePlatform" /> </el-form-item>

                        <el-form-item v-if="!form.createE_Invoice" prop="foO_DAT" label="發票日期">
                            <div>
                                <el-date-picker v-model="form.foO_DAT" type="date" value-format="timestamp" placeholder="選擇日期" @change="onFooDateChange"> </el-date-picker>
                                <el-alert v-if="!form.createE_Invoice && newestDate" type="warning" size="small" :closable="false" class="small-alert">
                                    最新發票日期：{{ newestDate | dateFormater("YYYY / MM / dd") }}
                                </el-alert>
                            </div>
                            <div>
                                <el-alert v-if="isFutureInvoiceDate" type="warning" size="small" :closable="false" class="future-invoice-alert">
                                    開立發票相關規定請至 財政部（<a href="https://law-out.mof.gov.tw/LawContent.aspx?id=FL006084" target="_blank"> 連結 </a>）查詢
                                </el-alert>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="!form.createE_Invoice" prop="foo" label="發票號碼">
                            <ahElInputInvoice v-model="form.foo" :key="form.foO_DAT" show-duplicate-hint :check-date="form.foO_DAT" :ioo="form.tioo" />
                            <ah-receipt-input v-model="form.foo" :suggestion-only="true" :presets="fooPrefixs"></ah-receipt-input>
                        </el-form-item>
                        <el-form-item label="開立備註">
                            <el-input v-model="form.mem" type="textarea" :autosize="{ minRows: 3 }" :maxlength="200" :show-word-limit="true" :disabled="isEInvoice"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">買受人資訊</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="vdR_SNO" label="買受人(客戶)">
                            <ah-select-client v-model="form.vdR_SNO" :disabled="isEInvoice" @change="onClientSelectChange" />
                        </el-form-item>
                        <el-form-item v-if="form.typ === 3" label="買受人統一編號" prop="e_InvoiceBuyeBSN" :disabled="isEInvoice" :rules="rules.e_InvoiceBuyeBSN">
                            <el-input v-model.trim="form.e_InvoiceBuyeBSN" readonly class="bsn-input" :disabled="true" style="width: 300px"></el-input>
                        </el-form-item>
                        <el-form-item prop="e_InvoiceBuyerEmail">
                            <template v-slot:label>
                                <div style="line-height: 1.5">買受人E-mail<br />(電子發票收件信箱)</div>
                            </template>
                            <el-input v-model.trim="form.e_InvoiceBuyerEmail" :disabled="isEInvoice" style="width: 300px" :maxlength="50" :show-word-limit="true" />
                        </el-form-item>
                        <el-form-item prop="e_InvoiceBuyerAddress" label="買受人地址">
                            <el-input v-model.trim="form.e_InvoiceBuyerAddress" :disabled="isEInvoice" style="width: 300px" :maxlength="100" :show-word-limit="true" />
                        </el-form-item>
                    </div>
                </div>
            </div>
            <center>
                <el-button v-if="form.sno && !isEInvoice" type="danger" @click="onDelete">刪除</el-button>
                <el-button @click="onCancel">取消</el-button>
                <el-button v-if="form.sno" type="primary" class="primary-action" @click="onEdit" :loading="isSubmitting">儲存</el-button>
                <el-button v-else type="primary" class="primary-action" @click="onSubmit" :loading="isSubmitting">送出</el-button>
            </center>
        </el-form>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import accounting from 'accounting-js';
import { mapState } from 'vuex';
import ahElSelectCny from '@/components/ui/ahElSelectCny.vue';
import ahReceiptInput from '@/components/ui/ahReceiptInput.vue';
import ahSelectClient from '@/components/ui/ahSelectClient.vue';
import ahElInputInvoice from '@/components/ui/ahElInputInvoice.vue';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';
import ahEInvoicePlatformLabel from '@/components/ui/ahEInvoicePlatformLabel.vue';
import ReimbursementSelectedTableView from '@/components/dashboard/Finance/ReimbursementInvoice/ReimbursementInvoiceAddLayout/ReimbursementSelectedTableView.vue';

export default {
    components: {
        // ahTip
        ahElSelectCny,
        ahReceiptInput,
        ahSelectClient,
        ahElInputInvoice,
        ahEInvoicePlatformLabel,
        ReimbursementSelectedTableView,
    },
    computed: {
        ...mapState({
            eInvoicePlatform: (state) => state.menu.companyInfo.eInvoiceInfo?.platform,
            hasEInvoiceService: (state) => state.menu.companyInfo.eInvoice,
        }),
        isFutureInvoiceDate() {
            const TODAY = moment().startOf('day');
            return moment(this.form.foO_DAT).isAfter(TODAY);
        },

        // 發票項目總金額
        invoiceItemTotal() {
            return _.sumBy(this.form.items, 'amt');
        },

        isEInvoice() {
            return !!this.form.e_InvoicePlatform;
        },

        eInvoiceCmp() {
            return this.$store.getters['menu/companyInfo'].eInvoiceInfo.platform;
        },

        hasFloatInItemPrice() {
            for (let i = 0; i < this.form.items.length; i += 1) {
                if (this.form.items[i].pri.toString().indexOf('.') !== -1) {
                    return true;
                }
            }
            return false;
        },
    },
    data() {
        const invoiceValidate = (rule, value, callback) => {
            if (!value) callback(new Error('請填寫發票號碼'));
            else if (value.length < 10) callback(new Error('請輸入完整發票號碼'));
            callback();
        };

        return {
            isInit: false,
            isSubmitting: false,
            selectedProjectSno: null,
            newestDate: null, // 最新發票日期
            fooPrefixs: [],
            nonTaxAmt: 0,
            useTaxIncludedAmt: false, // 只 UI 使用
            form: {
                sno: null,
                description: '',
                amT_TAX: 0,
                amt: 0,
                rat: 1,
                items: [],
                refenceInvoces: [],
                typ: 3, // 2:二聯式, 3:三聯式
                createE_Invoice: false, // false:手開, true:電子發票
                foO_DAT: null,
                foo: null,
                mem: '',
                vdR_SNO: null,
                e_InvoiceBuyerEmail: null,
                e_InvoiceBuyerAddress: null,
                e_InvoiceBuyerName: null,
                e_InvoiceBuyeBSN: null,
                e_InvoicePlatform: null,
                cny: 'TWD',
                comment: null,
                code: null,
                sendEmailRemind: true, // 是否發送E-mail
            },
            rules: {
                description: [
                    {
                        required: true,
                        message: '請填寫摘要',
                        trigger: ['blur', 'change'],
                    },
                ],
                amt: [
                    {
                        required: true,
                        message: '請填寫發票含稅總計',
                        trigger: 'blur',
                    },
                ],
                vdR_SNO: [
                    {
                        required: true,
                        message: '請選擇客戶',
                        trigger: 'change',
                    },
                ],
                foo: [
                    {
                        required: true,
                        validator: invoiceValidate,
                        trigger: 'blur',
                    },
                ],
                e_InvoiceBuyeBSN: [
                    {
                        required: true,
                        message: '三聯式發票必填統編，請至客戶資料填寫統編',
                        trigger: 'change',
                    },
                ],
                foO_DAT: [
                    {
                        required: true,
                        message: '請選擇發票日期',
                        trigger: 'blur',
                    },
                ],
                invoiceItemNam: [
                    {
                        required: true,
                        message: '請填寫品名',
                        trigger: 'blur',
                    },
                ],
                invoiceItemQty: [
                    {
                        required: true,
                        message: '請填數量',
                        trigger: 'blur',
                    },
                ],
                invoiceItemUnit: [
                    {
                        required: true,
                        message: '請填單位',
                        trigger: 'blur',
                    },
                ],
                invoiceItemPri: [
                    {
                        required: true,
                        message: '請填寫單價',
                        trigger: 'blur',
                    },
                ],
                invoiceItemAmt: [
                    {
                        required: true,
                        message: '請填寫金額',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    async mounted() {
        this.fetchNewestInvoiceDate();

        const { tioo } = this.$route.params;

        if (tioo) {
            // 載入專案資料
            await this.fetchInvoiceData(tioo);
        } else if (this.form.items.length === 0) {
            // 新增
            this.addInvoiceItem();
        }

        this.$refs.form.clearValidate();
        this.isInit = true;
    },
    methods: {
        onFooDateChange() {
            if (this.form.foO_DAT) this.fetchSerialNumber(this.form.foO_DAT);
        },
        fetchSerialNumber(datetime) {
            this.$api({
                url: 'InvoiceManagemnetPage/GetPrefix',
                params: { DAT: datetime },
                method: 'GET',
            }).then((resp) => {
                if (resp.data.prefixs.length > 0) {
                    this.fooPrefixs = _.filter(resp.data.prefixs, ['prefixType', 1]);
                    // this.form.foo = resp.data.prefixs[resp.data.prefixs.length - 1];
                }
            });
        },
        onAmtChanged() {
            this.autoFillEmptyInstallmentsAmt();
        },

        autoFillEmptyInstallmentsAmt() {
            this.form.amT_TAX = Math.round((this.form.amt / 1.05) * 0.05);
            const amtWithOutTax = Math.round(this.form.amt - this.form.amT_TAX);
            this.nonTaxAmt = amtWithOutTax;
            if (this.form.items.length > 0) {
                // 區分有手動輸入的分期金額(用品名判斷)
                const usedItems = [];
                const noneUsedItems = [];
                let usedItemsNonTaxedAmt = 0;
                let usedItemsTaxedAmt = 0;
                for (let i = 0; i < this.form.items.length; i += 1) {
                    if (this.form.items[i].iteM_NAM != null && this.form.items[i].iteM_NAM !== '') {
                        usedItems.push(this.form.items[i]);
                        usedItemsNonTaxedAmt += this.form.items[i].amt;
                        usedItemsTaxedAmt += this.form.items[i].taxedAmt;
                    } else {
                        noneUsedItems.push(this.form.items[i]);
                    }
                }

                // 將總金額分配到剩餘分期
                const remainNonTaxedAmt = amtWithOutTax - usedItemsNonTaxedAmt;
                const remainTaxedAmt = this.form.amt - usedItemsTaxedAmt;
                if (noneUsedItems.length > 0 && remainNonTaxedAmt > 0) {
                    const eachItemNonTaxedAmt = Math.floor(remainNonTaxedAmt / noneUsedItems.length);
                    const eachItemTaxedAmt = Math.floor(remainTaxedAmt / noneUsedItems.length);

                    // 只有一個分期
                    if (noneUsedItems.length === 1) {
                        noneUsedItems[0].qty = 1;
                        noneUsedItems[0].pri = eachItemNonTaxedAmt;
                        noneUsedItems[0].amt = eachItemNonTaxedAmt;
                        noneUsedItems[0].taxedPri = eachItemTaxedAmt;
                        noneUsedItems[0].taxedAmt = eachItemTaxedAmt;
                    }

                    // 多個分期，避免小數點問題，最後一個另外處理
                    if (noneUsedItems.length > 1) {
                        let filledNonTaxedAmt = 0;
                        let filledTaxedAmt = 0;
                        for (let j = 0; j < noneUsedItems.length - 1; j += 1) {
                            noneUsedItems[j].qty = 1;
                            noneUsedItems[j].pri = eachItemNonTaxedAmt;
                            noneUsedItems[j].amt = eachItemNonTaxedAmt;
                            noneUsedItems[j].taxedPri = eachItemTaxedAmt;
                            noneUsedItems[j].taxedAmt = eachItemTaxedAmt;
                            filledNonTaxedAmt += eachItemNonTaxedAmt;
                            filledTaxedAmt += eachItemTaxedAmt;
                        }

                        const lastIndex = noneUsedItems.length - 1;
                        const lastNonTaxedAmt = remainNonTaxedAmt - filledNonTaxedAmt;
                        const lastTaxedAmt = remainTaxedAmt - filledTaxedAmt;
                        noneUsedItems[lastIndex].qty = 1;
                        noneUsedItems[lastIndex].pri = lastNonTaxedAmt;
                        noneUsedItems[lastIndex].amt = lastNonTaxedAmt;
                        noneUsedItems[lastIndex].taxedPri = lastTaxedAmt;
                        noneUsedItems[lastIndex].taxedAmt = lastTaxedAmt;
                    }
                }
            }
        },

        onItemQtyChange(item) {
            // eslint-disable-next-line no-param-reassign
            item.amt = item.qty * item.pri;
            // eslint-disable-next-line no-param-reassign
            item.taxedAmt = item.qty * item.taxedPri;
            this.autoFillEmptyInstallmentsAmt();
        },
        onItemNonTaxedPriChange(item) {
            // eslint-disable-next-line no-param-reassign
            item.taxedPri = Math.round(item.pri * 1.05);
            // eslint-disable-next-line no-param-reassign
            item.amt = item.qty * item.pri;
            // eslint-disable-next-line no-param-reassign
            item.taxedAmt = item.qty * item.taxedPri;
            this.autoFillEmptyInstallmentsAmt();
        },
        onItemTaxedPriChange(item) {
            // eslint-disable-next-line no-param-reassign
            item.pri = Math.round(item.taxedPri / 1.05);
            // eslint-disable-next-line no-param-reassign
            item.amt = item.qty * item.pri;
            // eslint-disable-next-line no-param-reassign
            item.taxedAmt = item.qty * item.taxedPri;
            this.autoFillEmptyInstallmentsAmt();
        },

        onCancel() {
            this.$router.push({ name: 'reimbursement-invoice' });
        },

        onClientSelectChange(clientSno) {
            // 填入客戶統編
            this.$api({
                url: 'VendorManagementPage/GetVendorInfo',
                params: { SNO: clientSno },
                method: 'GET',
            }).then((resp) => {
                const FOUND = _.first(resp.data.item.vendorContacts);

                this.form.e_InvoiceBuyerEmail = FOUND?.eml;
                this.form.e_InvoiceBuyeBSN = resp.data.item.bsn;
                this.form.e_InvoiceBuyerName = resp.data.item.fnam;
                this.form.e_InvoiceBuyerEmail = resp.data.item.vendorContacts[0]?.eml;
                this.form.e_InvoiceBuyerAddress = resp.data.item.adr;
            });
            // 待補找不到處理
        },

        // 取得最後發票日期
        fetchNewestInvoiceDate() {
            this.$api({
                url: '/InvoiceManagemnetPage/GetNewestInvoceFOO_DATE',
                method: 'GET',
            }).then((resp) => {
                this.newestDate = resp.data.newestDate;
                console.log('invoice newest date: ', new Date(resp.data.newestDate));
            });
        },

        // 載入已有的專案資料 （編輯模式）
        async fetchInvoiceData(tioo) {
            try {
                const resp = await this.$api({
                    url: '/TranInvoice/GetTranInvoiceInfo',
                    method: 'GET',
                    params: { tioo },
                });

                this.form = resp.data;
                console.log('Reimbursement Invoice: ', resp.data);

                // 依amt自動計算未稅金額
                this.nonTaxAmt = Math.round(this.form.amt - this.form.amT_TAX);

                // 依items計算含稅金額
                resp.data.items.forEach((item) => {
                    // eslint-disable-next-line no-param-reassign
                    item.taxedPri = item.pri * 1.05;
                    // eslint-disable-next-line no-param-reassign
                    item.taxedAmt = item.amt * 1.05;
                });

                this.form.createE_Invoice = !!this.form.e_InvoicePlatform;
            } catch (e) {
                console.log(e);
            }
        },

        resetForm() {
            this.form = {
                typ: 3,
                cny: 'TWD',
                items: [],
                foo: null,
                foO_DAT: null,
                e_InvoiceBuyeBSN: '',
                amt: 0,
            };
            this.$refs.form.clearValidate();
            this.$refs.form.resetFields();
            this.addInvoiceItem();
        },

        // 增加發票項目
        addInvoiceItem() {
            this.form.items.push({
                iteM_NAM: '',
                qty: 1,
                pri: 0,
                taxedPri: 0,
                amt: 0,
                taxedAmt: 0,
                cny: 'TWD',
                unit: '式',
                key: Date.now(),
            });
            this.autoFillEmptyInstallmentsAmt();
        },

        // 刪除發票項目
        removeInvoiceItem(item) {
            this.form.items.splice(this.form.items.indexOf(item), 1);
            this.autoFillEmptyInstallmentsAmt();
        },

        // 送出表單
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        const code = this.getInvoiceValidateCode(this.form);

                        if (this.form.foo && !code) {
                            await this.$confirm('您輸入的發票號碼不存在於發票日期所屬營業稅申報期別，確定要儲存嗎？', {
                                confirmButtonText: '確定',
                                cancelButtonText: '取消',
                            });
                        }

                        // 總金額不可為0
                        if (this.form.amt <= 0) {
                            this.$message({
                                showClose: true,
                                type: 'error',
                                message: '發票金額不可為零',
                            });
                            return;
                        }

                        // 發票品項金額與發票總額不符
                        if (this.invoiceItemTotal !== this.nonTaxAmt) {
                            this.$message({
                                showClose: true,
                                type: 'error',
                                message: '發票項目總金額需等於税前金額',
                            });
                            return;
                        }

                        // 發票品項有小數點不可以電子發票開立
                        if (this.hasFloatInItemPrice && this.form.createE_Invoice) {
                            this.$message({
                                showClose: true,
                                type: 'error',
                                message: '發票項目中有小數點，無法以電子發票開立。',
                            });
                            return;
                        }

                        this.form.code = this.form.createE_Invoice ? 35 : code;

                        if (this.form.createE_Invoice) {
                            this.form.foo = null;
                            this.form.foO_DAT = null;
                        } else {
                            this.form.e_InvoiceBuyerName = undefined;
                            this.form.e_InvoiceOrderNo = undefined;
                        }

                        console.log('invoice form: ', this.form);

                        // 送出
                        this.isSubmitting = true;
                        await this.$api({
                            url: '/TranInvoice/CreateTranInvoice',
                            method: 'POST',
                            data: this.form,
                        });
                        this.$router.push({ name: 'reimbursement-invoice' });
                    } catch (e) {
                        console.log(e);
                    } finally {
                        this.isSubmitting = false;
                    }
                } else {
                    this.scrollViewToError();
                }
            });
        },

        onEdit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 總金額不可為0
                    if (this.form.amt <= 0) {
                        this.$message({
                            showClose: true,
                            type: 'error',
                            message: '發票金額不可為零',
                        });
                        return;
                    }

                    this.form.code = this.form.createE_Invoice ? 35 : this.getInvoiceValidateCode(this.form);

                    console.log('invoice form: ', this.form);

                    // 送出
                    this.isSubmitting = true;
                    this.$api({
                        url: '/TranInvoice/EditTranInvoice',
                        method: 'POST',
                        data: this.form,
                    })
                        .then(() => {
                            this.$router.push({ name: 'reimbursement-invoice' });
                        })
                        .finally(() => {
                            this.isSubmitting = false;
                        });
                } else {
                    this.scrollViewToError();
                }
            });
        },

        onDelete() {
            this.$confirm('確認要撤銷此發票？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.submitVoid();
                })
                .catch(() => {});
        },

        submitVoid() {
            this.$api({
                url: '/InvoiceManagemnetPage/VoidInvoice',
                method: 'post',
                data: {
                    sno: this.form.sno,
                    foO_CNL_DAT: Date.now(),
                    foO_CNL_MEM: '申請人自行撤銷',
                },
            })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: '發票已撤銷。',
                        type: 'success',
                    });
                    this.$router.push({ name: 'reimbursement-invoice' });
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        // 滑動到錯誤欄位
        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },

        // 發票項目最後加總欄位控制 (elmentsUI)
        invoiceItemsGetSummary(param) {
            const { columns, data } = param;
            const sums = [];

            // 每一格
            columns.forEach((column, index) => {
                // 第一格
                if (index === 0) {
                    sums[index] = '項目總金額（未稅）';
                    return;
                }

                // 其他格
                if (column.property === 'amt') {
                    const values = data.map((item) => Number(item[column.property]));
                    if (!values.every((value) => Number.isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!Number.isNaN(value)) {
                                return prev + curr;
                            }
                            return prev;
                        }, 0);
                        sums[index] = `${accounting.formatMoney(Number(sums[index]), { symbol: '', precision: 2 })} 元`;
                    } else {
                        sums[index] = 'N/A';
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },

        getInvoiceValidateCode(item) {
            if (!item.foo) return undefined;
            const isIncome = true;
            const fooMonth = moment(item.foO_DAT).month() + 1;
            const fooYear = moment(item.foO_DAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) return Number(`${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`);

            return undefined;
        },

        onInvoiceChange(val) {
            const INVOICE = _.chain(val)
                .map((o) => ({
                    sno: o.sno || null,
                    ioo: o.ioo,
                    amt: o.thisAmt,
                    cny: o.cny,
                    rat: o.rat,
                    deleted: o.deleted || false,
                }))
                .filter((o) => !(!o.sno && o.deleted))
                .value();
            this.form.refenceInvoces = [...INVOICE];
            this.form.amt = _.chain(val)
                .filter(['deleted', false])
                .sumBy((o) => Math.round(o.thisAmt * o.rat))
                .value();
            this.autoFillEmptyInstallmentsAmt();

            if (!this.form.sno && this.form.refenceInvoces.length === 1) {
                const FIRST = val[0];
                this.form.vdR_SNO = FIRST.vdR_SNO;
                this.onClientSelectChange(FIRST.vdR_SNO);
            }
        },

        onTypChange() {
            if (this.form.typ === 2) this.form.createE_Invoice = false;
        },

        isIteM_NAMDisabled(row) {
            return this.isEInvoice || row.iteM_NAM.trim() === '';
        },
        onDescriptionInputKeydown(event) {
            if (event.key === 'Enter' || event.code === 'Enter' || event.keyCode === 13) {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = false;
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss">
.invoice-add-page {
    .small-alert {
        margin: 3px 0 0 8px;
        line-height: 30px;
        padding: 3px 10px;
        display: inline-block;
        width: auto;
        vertical-align: top;

        .el-alert__description {
            margin-top: 0;
        }
    }
    .future-invoice-alert {
        margin-top: 10px;
        line-height: 30px;

        .el-alert__description {
            margin-top: 0;
        }
    }

    .invoice-item-table-area {
        margin-bottom: 10px;
        margin-left: 0px;

        @media (min-width: 992px) {
            margin-left: 200px;
        }
    }
    .invoice-item-table {
        border: 1px solid #ddd;
    }

    .invoice-item-table-below-contents {
        display: flex;
        margin: 15px 0;
        justify-content: space-between;
        gap: 20px;

        .note-text {
            font-size: 9pt;
            color: #888;
        }
    }

    .item-name input {
        padding-right: 55px;
    }

    .use-tax-included-checkbox {
        .el-checkbox__label {
            font-size: 9pt;
            font-weight: normal;
        }
    }
    .use-tax-included-hint {
        font-size: 9pt;
        color: #888;
    }
}
</style>
